import {
  GlobalEvents,
  SectionRenderer,
  SnippetElement,
  defineElement
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/shipping-info/shipping-info.ts
var ShippingInfo = class extends SnippetElement {
  connectedCallback() {
    GlobalEvents.on("cart:updated", () => __async(this, null, function* () {
      var _a;
      const html = yield SectionRenderer.renderSection(this.dataset.sectionId);
      const newInnerHtml = (_a = new DOMParser().parseFromString(html, "text/html").querySelector(`shipping-info`)) == null ? void 0 : _a.innerHTML;
      if (newInnerHtml != null)
        this.innerHTML = newInnerHtml;
    }));
  }
};
ShippingInfo = __decorateClass([
  defineElement("shipping-info")
], ShippingInfo);
export {
  ShippingInfo
};
